import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./Pages/Home";
import Footer from "./Components/Footer";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Projects from "./Pages/Projects";
import Navbar from "./Components/Navbar";
import WhatsAppButton from "./Components/whatsAppButton";
import Products from "./Pages/Products";
import Logos from "./Pages/Logos";
import Posters from "./Pages/Posters";
import PhoneButton from "./Components/phoneButton";
import Pricing from "./Pages/Pricing";
import PoliciesPage from "./Pages/Policies";

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <WhatsAppButton />
      <PhoneButton />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/footer" element={<Footer />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/products" element={<Products />} />
        <Route path="/logos" element={<Logos />} />
        <Route path="/posters" element={<Posters />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/policies" element={<PoliciesPage />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}
export default App;
